module.exports = __webpack_public_path__ + "img/aquisicao-de-cotacao.546d312b.svg";